
import { TimecardRow } from '../models/timecardrow';

export class TimeCard {

    timeCardId: number = 0;
    status: string = '';
    timecardRows: Array<TimecardRow> = [];
    empComment: string = '';
    message: string = '';

    get monTotal(): number {
        let hours: number = 0;
        this.timecardRows.forEach(timecardPost => hours = hours + Number(timecardPost.mon));
        return hours;
    }

    get tueTotal(): number {
        let hours: number = 0;
        this.timecardRows.forEach(timecardPost => hours = hours + Number( timecardPost.tue ) );
        return hours;
    }

    get wedTotal(): number {
        let hours: number = 0;
        this.timecardRows.forEach(timecardPost => hours = hours + Number( timecardPost.wed ) );
        return hours;
    }

    get thuTotal(): number {
        let hours: number = 0;
        this.timecardRows.forEach(timecardPost => hours = hours + Number( timecardPost.thu ) );
        return hours;
    }

    get friTotal(): number {
        let hours: number = 0;
        this.timecardRows.forEach(timecardPost => hours = hours + Number( timecardPost.fri ) );
        return hours;
    }

    get satTotal(): number {
        let hours: number = 0;
        this.timecardRows.forEach(timecardPost => hours = hours + Number( timecardPost.sat ) );
        return hours;
    }

    get sunTotal(): number {
        let hours: number = 0;
        this.timecardRows.forEach(timecardPost => hours = hours + Number( timecardPost.sun ) );
        return hours;
    }

    get total(): number {
        let hours: number = 0;
        this.timecardRows.forEach(timecardPost => hours = hours + Number( timecardPost.mon) );
        this.timecardRows.forEach(timecardPost => hours = hours + Number( timecardPost.tue) );
        this.timecardRows.forEach(timecardPost => hours = hours + Number( timecardPost.wed) );
        this.timecardRows.forEach(timecardPost => hours = hours + Number( timecardPost.thu) );
        this.timecardRows.forEach(timecardPost => hours = hours + Number( timecardPost.fri) );
        this.timecardRows.forEach(timecardPost => hours = hours + Number( timecardPost.sat) );
        this.timecardRows.forEach(timecardPost => hours = hours + Number( timecardPost.sun) );
        return hours;
    }

    constructor(timecard?: any) {
        if (!!timecard) {
            this.timecardRows = TimecardRow.fromJSONArray(timecard['timecardRows']);
        }
    }
}
